import { ICartBoxLine } from '@interfaces';
import { WPImage } from '@v2/utils/image';
import { OutOfStockTag } from '@components/common/boxes/edit.tags';

export default function OOSProductLine({ line }: { line: ICartBoxLine }) {
    return (
        <tr className={line.product.availability}>
            <td className="image">
                <WPImage src={line.product.featuredImgUrl}
                alt={line.product.featuredImgAlt || line.product.title} />
            </td>
            <td className="title">
                <div>{line.product.title}</div>
            </td>
            <OutOfStockTag/>
        </tr>
    );
}
